import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";

interface Item {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

interface Group {
  heading: string;
  items: Item[];
}

interface DashboardProps {
  menuGroups: Group[];
  logo: any;
}

export const Dashboard: React.FC<DashboardProps> = ({ menuGroups, logo }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

const [expandedGroup, setExpandedGroup] = useState(null);


const handleGroupClick = (groupIndex, group) => {
  // Toggle expansion if clicking the same group, otherwise expand the new one
  setExpandedGroup(expandedGroup === groupIndex ? null : groupIndex);
  
  // If expanding (or switching to) a new group, activate its first item
  if (expandedGroup !== groupIndex && group.items.length > 0) {
    const firstItem = group.items[0];
    setActiveItem(firstItem.label);
    if (firstItem.onClick) {
      firstItem.onClick();
    }
  }
};

const handleItemClick = (label, onClick) => {
  setActiveItem(label);
  if (onClick) {
    onClick();
  }
};

  return (
    <div className="relative border h-full">
      <button
        className="block absolute md:hidden p-2 text-gray-600 focus:outline-none"
        onClick={toggleSidebar}
      >
        <FiMenu size={24} />
      </button>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 md:hidden"
          onClick={closeSidebar}
        ></div>
      )}

      <div
        className={`w-[70vw] md:w-[30vw] lg:w-[20vw] xl:w-[15vw] py-2 absolute md:relative top-0 left-0 z-20 h-full bg-white border-r pr-2 pl-3 overflow-y-auto overflow-x-hidden transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
          } md:translate-x-0 transition-transform duration-300 ease-in-out`}
      >
        <div
          className="w-16 h-16 flex cursor-pointer"
          onClick={() => (window.location.href = "/home")}
        >
          <img className="h-full w-full mx-auto" src={logo} alt="logo" />
        </div>

     {menuGroups.map((group, index) => (
      <div key={index} className="my-2">
        <div
          className="pl-3  p-2 text-sm text-gray-400 uppercase tracking-wider my-2 flex items-center justify-between cursor-pointer"
          onClick={() => handleGroupClick(index, group)}
        >
          <span className=" text-md text-black font-semibold">{group.heading}</span>
          <span className="text-gray-500 text-xl">
            {expandedGroup === index ? '−' : '+'}
          </span>
        </div>
        
        {expandedGroup === index && (
          <ul className="space-y-2">
            {group.items.map((item, idx) => (
              <li
                key={idx}
                className={`pl-3 flex items-center space-x-3 cursor-pointer py-1 pr-2 rounded-lg transition duration-200 ${
                  activeItem === item.label
                    ? "bg-gray-300 text-gray-800"
                    : "hover:bg-gray-100 text-gray-700"
                }`}
                onClick={() => handleItemClick(item.label, item.onClick)}
              >
                <span className="text-gray-500 text-lg">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    ))}
      </div>
    </div>
  );
};
